import { Link } from 'react-router-dom'
import './ToolCard.css'

/** Props match the shape of a registry entry from src/data/tools.js. */
function ToolCard({ icon, name, blurb, path, categoryLabel }) {
  return (
    <Link to={path} className="tool-card">
      <div className="tool-card-icon" aria-hidden="true">
        {icon}
      </div>
      <div className="tool-card-content">
        <h3>{name}</h3>
        <p>{blurb}</p>
        {categoryLabel && <span className="tool-category">{categoryLabel}</span>}
      </div>
    </Link>
  )
}

export default ToolCard
